<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <EstimatedAnnualEnergyConsumptionFormPart
        @change="onChange"
        @result="onResult"
      />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import EstimatedAnnualEnergyConsumptionFormPart from 'chimera/homeBatteries/components/form/parts/estimatedAnnualEnergyConsumption/EstimatedAnnualEnergyConsumptionFormPart.nl'
import Step3 from '~/pages/offertes-aanvragen/je-gegevens'

export default {
  name: 'ElectricityEstimationFormStep',

  components: {
    EstimatedAnnualEnergyConsumptionFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  data: () => ({
    willTransitionOnValid: true,
  }),

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(Step3)
    },
  },
}
</script>
